module.exports = {"new":{"text":"Хүлээн авсан","status":"processing","color":"#581845"},"progressing":{"text":"Хүргэлтэд гарсан","status":"default","color":"#900c3f"},"processed":{"text":"Хүргэгдсэн","status":"success","color":"#c70039"},"changed":{"text":"Бараа өөрчлөгдсөн","status":"warning","color":"#ff5733"},"cancelled":{"text":"Цуцлагдсан","status":"error","color":"#ffc305"}}


//////////////////
// WEBPACK FOOTER
// ./src/containers/Orders/statusEnum.json
// module id = 253
// module chunks = 0